import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";

import Landing from "@/pages/candidate/Landing";
import JobDescriptionPage from "@/pages/candidate/JobDescriptionPage";
import ApplyForm from "@/pages/candidate/ApplyForm";

import AttendanceVerify from "@/pages/candidate/AttendanceVerify";
import CandidateDetails from "@/pages/candidate/CandidateDetails";
import ThankYou from "@/pages/candidate/ThankYou";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/components/admin/AdminLayout";
import Modules from "@/pages/admin/Modules";
import CreateJobRole from "@/pages/admin/CreateJobRole";
import CreateJobDescription from "@/pages/admin/CreateJobDescription";
import CreateForm from "@/pages/admin/CreateForm";
import ManageDegrees from "@/pages/admin/ManageDegrees";
import ManageCandidates from "@/pages/admin/ManageCandidates";
import ManageColleges from "@/pages/admin/ManageColleges";
import ManageJobRoleMaster from "@/pages/admin/ManageJobRoleMaster";
import AttendanceReport from "@/pages/admin/AttendanceReport";
import WhatsAppLogs from "@/pages/admin/WhatsAppLogs";
import AttendanceExport from "@/pages/admin/AttendanceExport";
import ViewApplicants from "@/pages/admin/ViewApplicants";
import ChangePassword from "@/pages/admin/ChangePassword";
import RequireAuth from "@/components/admin/RequireAuth";
import NotFound from "@/pages/NotFound";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    {/* Candidate portal */}
                    <Route path="/" element={<Landing />} />
                    <Route path="/jd/:id" element={<JobDescriptionPage />} />
                    <Route path="/apply/:roleId" element={<ApplyForm />} />
                    <Route path="/verify" element={<AttendanceVerify />} />
                    <Route
                        path="/verify/details"
                        element={<CandidateDetails />}
                    />
                    <Route path="/verify/thank-you" element={<ThankYou />} />
                    {/* Backward compatibility for old links */}
                    <Route
                        path="/attend"
                        element={<Navigate to="/verify" replace />}
                    />
                    <Route
                        path="/attend/details"
                        element={<Navigate to="/verify/details" replace />}
                    />
                    <Route
                        path="/attend/thank-you"
                        element={<Navigate to="/verify/thank-you" replace />}
                    />
                    {/* Legacy redirects */}
                    <Route
                        path="/jobs"
                        element={<Navigate to="/" replace />}
                    />
                    <Route
                        path="/jobs/:id"
                        element={<Navigate to="/" replace />}
                    />

                    {/* Hidden admin portal */}
                    <Route path="/bbrgadminacc" element={<AdminLogin />} />
                    <Route
                        element={
                            <RequireAuth>
                                <AdminLayout />
                            </RequireAuth>
                        }
                    >
                        <Route
                            path="/bbrgadminacc/modules"
                            element={<Modules />}
                        />
                        <Route
                            path="/bbrgadminacc/job-role"
                            element={<CreateJobRole />}
                        />
                        <Route
                            path="/bbrgadminacc/job-description"
                            element={<CreateJobDescription />}
                        />
                        <Route
                            path="/bbrgadminacc/form"
                            element={<CreateForm />}
                        />
                        <Route
                            path="/bbrgadminacc/degrees"
                            element={<ManageDegrees />}
                        />
                        <Route
                            path="/bbrgadminacc/colleges"
                            element={<ManageColleges />}
                        />
                        <Route
                            path="/bbrgadminacc/job-role-master"
                            element={<ManageJobRoleMaster />}
                        />
                        <Route
                            path="/bbrgadminacc/attendance-report"
                            element={<AttendanceReport />}
                        />
                        <Route
                            path="/bbrgadminacc/candidates"
                            element={<ManageCandidates />}
                        />
                        <Route
                            path="/bbrgadminacc/whatsapp-logs"
                            element={<WhatsAppLogs />}
                        />
                        <Route
                            path="/bbrgadminacc/attendance-export"
                            element={<AttendanceExport />}
                        />
                        <Route
                            path="/bbrgadminacc/applicants"
                            element={<ViewApplicants />}
                        />
                        <Route
                            path="/bbrgadminacc/change-password"
                            element={<ChangePassword />}
                        />
                    </Route>

                    <Route path="*" element={<NotFound />} />
                </Routes>
            </BrowserRouter>
            <Toaster
                position="top-right"
                toastOptions={{
                    style: {
                        background: "#0F1F38",
                        color: "#F7F5F0",
                        border: "1px solid #1A3254",
                        borderRadius: "4px",
                    },
                }}
            />
        </div>
    );
}

export default App;
